import React from "react";

const SubscribeForm = ({ email, setEmail, subscribe, isMobile }) => {
    const handleInputChange = (e) => setEmail(e.target.value);
    const handleSubscribe = () => {
        if (email) subscribe(email);
    };

    return (
        <button className="button bg-[#C5D4E2] text-black w-full mt-6 lg:mt-[32px] pill-input-button" style={{ height: "49px" }}>
            <div className="flex basis-auto flex-auto justify-between items-center">
                <input
                    type="text"
                    className={`${isMobile ? "b3__semibold" : "b2__semibold"} justify-start placeholder-black`}
                    placeholder="ENTER YOUR EMAIL"
                    value={email}
                    onChange={handleInputChange}
                    aria-label="Email"
                    style={{ background: "none", border: "none", padding: 0, color: "black" }}
                />
                <div className={`${isMobile ? "b3" : "b2"} flex gap-x-[8px] justify-end items-center`} onClick={handleSubscribe}>
                    <div className="font-normal max-lg:underline max-lg:text-sm" role="button" aria-label="Subscribe">
                        Subscribe
                    </div>
                    <div className="icon icon-ur-arrow text-[17px] lg:text-[19px]" />
                </div>
            </div>
        </button>
    );
};

export default SubscribeForm;
